<template>
  <modal v-if="showModal" @close="closeModal">
    <template slot="header">
      <h4 class="modal-title">Add Note</h4>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-field>
        <label>Note</label>
        <md-textarea v-model="form.note" md-autogrow required></md-textarea>
      </md-field>
      <span v-show="errorList.length > 0" class="text-danger">{{
        errorList[0]
      }}</span>
    </template>

    <template slot="footer">
      <md-button
        class="md-success md-sm"
        @click.native.prevent="onSubmit"
        :disabled="hasSubmit"
      >
        <md-icon class="material-icons">check</md-icon>Submit</md-button
      >&nbsp;
      <md-button class="md-danger md-sm" @click.native.prevent="closeModal">
        <md-icon class="material-icons">close</md-icon>Close
      </md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.form.quoteId = this.$route.params.quoteId;
  },
  data() {
    return {
      hasSubmit: false,
      errorList: [],
      form: {
        note: "",
        quoteId: ""
      }
    };
  },
  methods: {
    clearModal() {
      this.form.note = "";
      this.hasSubmit = false;
      this.errorList = [];
    },
    closeModal() {
      this.clearModal();
      this.$emit("closeModal", false);
    },
    async onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("quote/createQuoteNote", this.form)
        .then(() => {
          this.clearModal();
          this.$emit("closeModal", true);
        })
        .catch(error => {
          this.hasSubmit = false;
          if (error.response.status === 400) {
            // handle validation error
            let validationErrorDictionary = error.response.data.errors;
            for (var fieldName in validationErrorDictionary) {
              if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                this.errorList.push(
                  "- " + validationErrorDictionary[fieldName]
                );
              }
            }
          } else {
            this.errorList.push(error.response.data);
          }
        });
    }
  }
};
</script>

<style></style>
